import React from "react";
import theme from "@/foundation/Theme";
import SimilarRecipeSlider from "./SimilarRecipeSlider";
import {
  Wrapper,
  TopContainer,
  HeaderBox,
  Heading,
  BrowseCta,
  BottomContainer,
} from "./style";

function SimilarRecipeList({ data = {}, setShowModal = () => {} }) {
  const { title, ctaTitle, similarList } = data || {};
  return (
    <Wrapper>
      <TopContainer>
        <HeaderBox>
          {title && <Heading variant="heading5">{title}</Heading>}
        </HeaderBox>
      </TopContainer>
      <BottomContainer>
        <SimilarRecipeSlider data={similarList} setShowModal={setShowModal} />
      </BottomContainer>
    </Wrapper>
  );
}

export default SimilarRecipeList;
